import { useMemo } from 'react'
import { ControlServicePromiseClient } from '@trustero/trustero-api-web/lib/model/control_grpc_web_pb'
import {
  BatchListControlPoliciesRequest,
  BatchListControlPoliciesResponse,
  ListControlPoliciesRequest,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import { PolicyRecords } from '@trustero/trustero-api-web/lib/model/policy_pb'
import { GrpcResponse, NewGrpcResponse } from '../../hooks/types'
import { useSwrImmutableGrpc } from '../../useSwrImmutableGrpc'

export const useControlPolicies = (
  controlId?: string,
  shouldFetch = true,
): GrpcResponse<PolicyRecords> => {
  const request = useMemo(
    () => new ListControlPoliciesRequest().setControlId(controlId || ''),
    [controlId],
  )
  const { response } = useSwrImmutableGrpc(
    ControlServicePromiseClient.prototype.listControlPolicies,
    request,
    !!controlId && shouldFetch,
  )
  return NewGrpcResponse(response)
}

export const useBatchControlPolicies = (
  controlIds: string[],
  shouldFetch = true,
): GrpcResponse<BatchListControlPoliciesResponse> => {
  const request = useMemo(
    () =>
      new BatchListControlPoliciesRequest().setControlIdsList(controlIds || []),
    [controlIds],
  )
  const { response } = useSwrImmutableGrpc(
    ControlServicePromiseClient.prototype.batchListControlPolicies,
    request,
    controlIds.length > 0 && shouldFetch,
  )
  return NewGrpcResponse(response)
}
